import React from 'react';

import { appRoutes } from '@clearverify/constants';

import { DEFAULT_AVATAR } from 'src/assets';
import { BaseLayout } from 'src/components/common';
import { useGlobalState } from 'src/hooks/shared';
import { useCurrentUser, useUserAvatar } from 'src/hooks/user';

import { LayoutHeader, LayoutLeftMenu } from './components';

export const VerifierManagerLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { leftMenuDrawerState } = useGlobalState();

  const { user, userFullName } = useCurrentUser();
  const { userAvatar } = useUserAvatar(user?.id);

  return (
    <BaseLayout
      header={<LayoutHeader />}
      rootRoute={appRoutes.inbox.index}
      leftMenu={<LayoutLeftMenu />}
      content={children}
      currentUserFullName={userFullName}
      currentUserAvatarUrl={userAvatar?.downloadUrl}
      defaultLogoUrl={DEFAULT_AVATAR}
      leftMenuDrawerState={leftMenuDrawerState}
    />
  );
};
